import { defineComponent } from 'vue'
import { ACTION_TYPES as CHALLENGES_ACTION_TYPES } from '@/store/modules/challenges'
import { MUTATION_TYPES as UI_MUTATION_TYPES } from '@/store/modules/ui'
import UserMixin from '@/util/UserMixin'

export default defineComponent({
  mixins: [UserMixin],
  data () {
    return {}
  },
  computed: {
    /*challenge () {
      return this.$store.state.challenges.detail.data
    },*/
    isLoadingChallenge () {
      return this.$store.state.challenges.detail.loading
    },
    activities () {
      return this.challenge.activities
    },
    industries () {
      return this.challenge.industries
    },
    technologies () {
      return this.challenge.technology
    },
    domains () {
      return this.challenge.domains
    },
    stages () {
      return this.challenge.stages
    },
    challengeId (): Number {
      return Number(this.$route.params.id)
    },
    canUserEditChallenge () {
      return this.isOwner || (this.userId && this.challenge && this.challenge.creator && this.userId === this.challenge?.creator?.id)
    },
    challenges () {
      return this.$store.state.challenges.listData.data
    },
    accessibleChallengeStatusses () {
      return this.$store.getters.accessibleChallengeStatusses
    },
    challengeGoals () {
      if (this.challenge && this.challenge.title) {
        const combined = [
          ...this.activities,
          ...this.industries,
          ...this.technologies,
          ...this.domains,
          ...this.stages,
        ]
        return combined.map(item => item.label)
      }

      return []
    },
  },
  methods: {
    fetchChallengeDetail (challengeId) {
      this.$store.dispatch(CHALLENGES_ACTION_TYPES.FETCH_CHALLENGE_DETAIL, Number(challengeId))
    },
    showEditChallengePanel () {
      this.$store.commit(UI_MUTATION_TYPES.SHOW_SIDE_PANEL, {
        'component': 'manage-challenge-panel',
        metaData: this.challenge,
      })
    }
  },
})
